// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1O2Qw","movie":"WYYHr","movie-name":"_38IHr","comment":"h6O6y","rating":"_2GXV0"};